import type { MeResponse } from "@/adapters/api";
import { useMe } from "@/hooks/use-me.ts";
import { useAuth } from "@/store/use-auth";

export type SessionStatus =
	| "anonymous"
	| "loading"
	| "onboarding"
	| "orphan"
	| "ready";

interface MeQueryState {
	isPending: boolean;
	isError: boolean;
	data?: MeResponse;
}

export function resolveSessionStatus(
	hasSession: boolean,
	me: MeQueryState,
): SessionStatus {
	if (!hasSession) return "anonymous";
	if (me.isPending) return "loading";
	if (me.isError || !me.data) return "ready";
	if (me.data.user.onboarding) return "onboarding";
	if (me.data.accounts.length === 0) {
		// An API that predates the `onboarding` flag omits it entirely; fall back
		// to the legacy rule so an account-less user still reaches the wizard.
		return me.data.user.onboarding === false ? "orphan" : "onboarding";
	}
	return "ready";
}

export function useSessionState(): SessionStatus {
	const session = useAuth((state) => state.session);
	const me = useMe();

	return resolveSessionStatus(!!session, me);
}
